import { Options } from 'http-proxy-middleware'

export const proxyOptions: Options = {
  target: process.env.NEXT_PUBLIC_BACKEND_URL,
  changeOrigin: true,
}

// Modal Type
export enum ModalType {
  Auth = 'AUTH_MODAL',
}

// authFormTypes.ts
export enum AuthFormType {
  Login = 'LOGIN',
  Register = 'REGISTER',
  ForgotPassword = 'FORGOT_PASSWORD',
}
